window.$ = window.jQuery = require('jquery');
require('./vendor/modernizr-custom');
require("@popperjs/core");
require ('bootstrap');
require('jquery-nice-select');
require('./vendor/form-builder');
require("@fancyapps/fancybox");
require('./../../node_modules/jquery-visible/jquery.visible.min.js');
require('./vendor/search_select.js');
require('jquery-touchswipe');

import objectFitVideos from 'object-fit-videos';
import objectFitImages from 'object-fit-images';

import gaEvents from './vendor/ga-events';
import forms from './_forms';
import sliders from './_sliders';
import pagination from './_pagination';
import gMap from './_map';
import displayHomes from './_display_homes';
import fancybox from './_fancybox';
import navigation from './_navigation';
import accordions from './_accordions';
import popout from './_popout';
import autoplayVideos from './_autoplay_videos';
import floorplan from './_floorplan';
import floorplanSimple from './_floorplan_simple';
import filters from './_filters';
import inclusions from './_inclusions';
import select from './_select';
import salesConsultants from './_sales_consultants';
import facades from './_facades';
import misc from './_misc';
import tabs from './_tabs';
import promotionBanner from './_promotion_banner';
import pageNav from './_page_nav';
import series from './_series';
import tooltip from './_tooltip';

$(function() { // Shorthand for $( document ).ready()
    "use strict";
    // Your js script is below this line
    // --------------------------------------------------------------------- //

    window.GA = new gaEvents();
    GA.init();

    window.Forms = new forms();
    Forms.init();

    window.Sliders = new sliders();
    Sliders.init();

    window.Pagination = new pagination();
    Pagination.init();

    window.GMap = new gMap();
    GMap.init();

    window.DisplayHomes = new displayHomes();
    DisplayHomes.init();

    window.Fancybox = new fancybox();
    Fancybox.init();

    window.Navigation = new navigation();
    Navigation.init();

    window.Accordions = new accordions();
    Accordions.init();

    window.Popout = new popout();
    Popout.init();

    window.AutoplayVideos = new autoplayVideos();
    AutoplayVideos.init();

    window.Floorplan = new floorplan();
    Floorplan.init();

    window.FloorplanSimple = new floorplanSimple();
    FloorplanSimple.init();

    window.Filters = new filters();
    Filters.init();

    window.Inclusions = new inclusions();
    Inclusions.init();

    window.Select = new select();
    Select.init();

    window.SalesConsultants = new salesConsultants();
    SalesConsultants.init();

    window.Facades = new facades();
    Facades.init();

    window.Misc = new misc();
    Misc.init();

    window.PromotionBanner = new promotionBanner();
    PromotionBanner.init();

    window.PageNav = new pageNav();
    PageNav.init();

    window.Series = new series();
    Series.init();
    
    window.Tooltip = new tooltip();
    Tooltip.init();

    window.Tabs = new tabs();
    Tabs.init();

    $(function() {
        // WebP background image fallback swap
        const checkWebp = function () {
            if (!Modernizr.webp) {
                let $elements = $('*[data-webp-bg-fallback]');
                $elements.each(function() {
                    let fallback = $(this).data('webp-bg-fallback');
                    $(this).css('background-image', 'url(' + fallback + ')');
                });

                // Update img's with fallback
                let $images = $('*[data-webp-image-fallback]');
                $images.each(function() {
                    let fallback =  $(this).data('webp-image-fallback');
                    $(this).attr('src', fallback);
                    $(this).removeAttr('srcset');
                });
            }
        };

        $(document).on('ajaxUpdate', function(event, context) {
            checkWebp();
        });
        checkWebp();

        if(typeof Cocoen !== 'undefined'){
            Cocoen.parse(document.body);
        }

        $(window).trigger('resize');
        $(window).trigger('scroll');

        $('html').addClass('ready');
    });

    // Sets inputs as filled when Google autocomplete prefills them
    $(window).on('load', function() {
        $('input:-webkit-autofill').each(function(){
            $(this).parents('.form-group').addClass('focused filled');
        });
    });

    objectFitVideos();
    objectFitImages('img');
});